/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Enum_Custom_Page_Icon_EnvelopeiconInputs */

const en_enum_custom_page_icon_envelopeicon = /** @type {(inputs: Enum_Custom_Page_Icon_EnvelopeiconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Envelope`)
};

const de_enum_custom_page_icon_envelopeicon = /** @type {(inputs: Enum_Custom_Page_Icon_EnvelopeiconInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Briefumschlag`)
};

/**
* | output |
* | --- |
* | "Envelope" |
*
* @param {Enum_Custom_Page_Icon_EnvelopeiconInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const enum_custom_page_icon_envelopeicon = /** @type {((inputs?: Enum_Custom_Page_Icon_EnvelopeiconInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Enum_Custom_Page_Icon_EnvelopeiconInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_enum_custom_page_icon_envelopeicon(inputs)
	return de_enum_custom_page_icon_envelopeicon(inputs)
});